// Biblioteca de vídeos (sections/main-video-watch.liquid): clicar num vídeo da lista lateral
// troca o vídeo principal sem recarregar a página. Busca a página do vídeo (cada vídeo tem a sua
// URL /pages/videos/<handle>), troca o bloco [data-video-main] e atualiza título, descrição,
// canonical e a URL (history.pushState). Os links continuam sendo links normais: sem JS, ou se a
// busca falhar, o navegador abre a página do vídeo.
(() => {
  const root = document.querySelector('[data-video-library]');
  if (!root || root.dataset.videoLibraryReady) return;
  root.dataset.videoLibraryReady = 'true';

  const cache = new Map();
  let pending = null;

  const fetchPage = (url) => {
    if (!cache.has(url)) {
      const request = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => new DOMParser().parseFromString(html, 'text/html'))
        .catch((error) => {
          cache.delete(url);
          throw error;
        });
      cache.set(url, request);
    }
    return cache.get(url);
  };

  const setMeta = (selector, attribute, value) => {
    const element = document.head.querySelector(selector);
    if (element && value) element.setAttribute(attribute, value);
  };

  const markCurrent = (url) => {
    const path = new URL(url, window.location.origin).pathname;
    root.querySelectorAll('[data-video-link]').forEach((link) => {
      const isCurrent = new URL(link.href).pathname === path;
      if (isCurrent) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const swapTo = async (url, { push }) => {
    const token = Symbol('swap');
    pending = token;
    root.classList.add('is-loading');
    try {
      const doc = await fetchPage(url);
      if (pending !== token) return;
      const nextMain = doc.querySelector('[data-video-main]');
      const currentMain = root.querySelector('[data-video-main]');
      if (!nextMain || !currentMain) throw new Error('video main not found');

      currentMain.querySelectorAll('video').forEach((video) => video.pause());
      currentMain.replaceWith(document.importNode(nextMain, true));

      document.title = doc.title;
      setMeta('meta[name="description"]', 'content', doc.querySelector('meta[name="description"]')?.content);
      setMeta('link[rel="canonical"]', 'href', doc.querySelector('link[rel="canonical"]')?.href);
      ['og:title', 'og:description', 'og:url', 'og:image', 'og:image:secure_url'].forEach((property) => {
        setMeta(`meta[property="${property}"]`, 'content', doc.querySelector(`meta[property="${property}"]`)?.content);
      });

      if (push) history.pushState({ videoLibrary: true }, '', url);
      markCurrent(url);

      const newMain = root.querySelector('[data-video-main]');
      const video = newMain.querySelector('video');
      if (video) video.play().catch(() => {});
      if (newMain.getBoundingClientRect().top < 0) {
        newMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (error) {
      if (pending === token) window.location.assign(url);
    } finally {
      if (pending === token) root.classList.remove('is-loading');
    }
  };

  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-video-link]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-current') === 'page') return;
    swapTo(link.href, { push: true });
  });

  // Pré-carrega a página do vídeo quando o mouse passa por cima (a troca fica instantânea).
  root.addEventListener('pointerenter', (event) => {
    const link = event.target.closest?.('[data-video-link]');
    if (link && link.getAttribute('aria-current') !== 'page') fetchPage(link.href).catch(() => {});
  }, true);

  history.replaceState({ videoLibrary: true }, '', window.location.href);
  window.addEventListener('popstate', (event) => {
    if (event.state && event.state.videoLibrary) swapTo(window.location.href, { push: false });
  });
})();
